
import React, { useEffect, useState } from "react";
import Header from "../components/headerfooter/Header";
import Footer from "../components/headerfooter/Footer";
import CallToAction from "../components/home/CallToAction";
import MobileFooter from "../components/MobileFooter";
import axios from "axios";
import { REACT_APP_API_PORT } from "../Api";
import { Helmet } from "react-helmet";
import Loader from "../components/Loader";

const Privacy = () => {
  const [meta,setMeta] = useState([])
  const [isLoading,setisLoading] = useState(false)
  const fetchMetaData = async () => {
    try {
      setisLoading(true);
      const res = await axios.get(
        `${REACT_APP_API_PORT}user/homepage/page-seo-details/Privacy Page`
      );
      if (res.data.status) {
        setMeta(res.data.data)
      }
    } catch (err) {
      console.error(err);
    } finally {
      setisLoading(false);
    }
  };

  useEffect(()=>{
    fetchMetaData()
  },[])

  return (
    <>
    <Helmet>
        <title>{meta?.meta_title}</title>
        <meta name="description" content={meta?.meta_description} />
        <meta name="keywords" content={meta?.meta_keywords} />
      </Helmet>
     <Loader isLoading={isLoading} />
      {/* <TopBar /> */}
      <Header />
      <div className="flex justify-center bg-black text-white pb-14 relative">
    
        <div className="w-full px-4">
          <div className="lg:w-3/5 w-full mx-auto mt-32 ">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight drop-shadow-[0_2px_10px_rgba(0,0,0,0.2)]">
                Privacy Policy for <span className="gradient-text">Next Future AI</span>
            </h1>
            <span className="text-gray-400 text-sm italic">
             Updated on Wed, feb 25, 2026
            </span>
           <div className="mt-10">

          <p>
            Welcome to NextFutureAI ("we", "our", or "us"). Your privacy is important to
            us. This Privacy Policy explains how we collect, use, and protect your
            information when you visit and use our website
            <strong> https://nextfutureai.com/</strong> ("Website").
          </p>

          <h3 className="text-xl font-extrabold mt-10">Information We Collect</h3>
          <p>We may collect the following information when you use our platform:</p>
          <ul className="list-disc pl-5">
            <li>Your name, email address, and profile information during signup or login.</li>
            <li>Information received through Google login or other authentication methods.</li>
            <li>Usage data such as pages visited, prompts accessed, courses enrolled, and activity on the platform.</li>
            <li>Technical data including IP address, device type, browser information, and approximate location.</li>
          </ul>

          <h3 className="text-xl font-extrabold mt-10">How We Use Your Information</h3>
          <p>Your information is used to:</p>
          <ul className="list-disc pl-5">
            <li>Provide access to AI tools, courses, prompts, and platform features.</li>
            <li>Improve website performance, security, and user experience.</li>
            <li>Send important updates, announcements, or support messages.</li>
            <li>Analyze usage trends to enhance our services.</li>
          </ul>

          <h3 className="text-xl font-extrabold mt-10">Third-Party Services</h3>
          <p>
            Our website may integrate third-party services such as Google authentication,
            analytics tools, chat widgets, or marketing tools. These services may collect
            data according to their own privacy policies. We are not responsible for
            external third-party practices.
          </p>

          <h3 className="text-xl font-extrabold mt-10">Cookies & Tracking</h3>
          <p>
            We may use cookies and similar technologies to remember your preferences,
            improve performance, and understand how users interact with our platform.
            You can control cookies through your browser settings.
          </p>

          <h3 className="text-xl font-extrabold mt-10">Data Sharing</h3>
          <p>
            We do not sell or rent your personal information. Data may be shared only
            when required by law, to protect our platform, or with trusted service
            providers that help operate our website.
          </p>

          <h3 className="text-xl font-extrabold mt-10">Data Security</h3>
          <p>
            We implement reasonable security measures to protect your information.
            However, no internet-based service is completely secure, and we cannot
            guarantee absolute protection.
          </p>

          <h3 className="text-xl font-extrabold mt-10">User Rights</h3>
          <p>
            You may request access, update, or deletion of your information by contacting
            us through our website contact page.
          </p>

          <h3 className="text-xl font-extrabold mt-10">Children’s Privacy</h3>
          <p>
            NextFutureAI is not intended for children under the age of 13, and we do not
            knowingly collect personal data from minors.
          </p>

          <h3 className="text-xl font-extrabold mt-10">Policy Updates</h3>
          <p>
            We may update this Privacy Policy from time to time. Changes will be posted
            on this page, and continued use of the website means you accept the updated policy.
          </p>

          <h3 className="text-xl font-extrabold mt-10">Contact</h3>
          <p>
            If you have any questions regarding this Privacy Policy, please contact us
            through https://nextfutureai.com/.
          </p>

        </div>
          </div>
        </div>
      </div>
      <CallToAction />
      <Footer />
      <MobileFooter />
    </>
  );
};

export default Privacy;
